import React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";

/* eslint-disable react/prop-types */
const transactionColumns = [
  { Header: "Date", accessor: "date", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "Time", accessor: "time", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "Batch No", accessor: "batchNo", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "Invoice No", accessor: "invoiceNo", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "TID", accessor: "tid", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "MID", accessor: "mid", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "Card Holder Name", accessor: "cardHolderName", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "Card Type", accessor: "cardtype", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "Masked Card No", accessor: "maskedCardNo", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "RRN", accessor: "rrn", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "Auth", accessor: "auth", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "Amount", accessor: "amount", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "Settlement Amount", accessor: "settlementAmount", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "MDR HNB", accessor: "mdrHnb", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "MDR DMS", accessor: "mdrDms", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "MDR YC", accessor: "mdrYc", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "MDR MF", accessor: "mdrMf", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "Currency", accessor: "currency", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "Status", accessor: "status", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "Settlement Status", accessor: "settlementStatus", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "Host Ref", accessor: "hostRef", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
  { Header: "Serial Number", accessor: "serialNumber", align: "left", Cell: ({ value }) => value ?? "-", headerSx: { whiteSpace: "nowrap" } },
];
/* eslint-enable react/prop-types */

function TransactionsDialog({ open, onClose, transactions, settlementRecord }) {
  const transactionRows = Array.isArray(transactions) ? transactions : [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle>
        Transactions for Voucher No: {settlementRecord?.voucherNo ?? "N/A"}
      </DialogTitle>
      <DialogContent>
        <MDBox mt={2}>
          {transactionRows.length === 0 ? (
            <MDBox textAlign="center" py={3}>
              No transactions found for this settlement record.
            </MDBox>
          ) : (
            <DataTable
              table={{ columns: transactionColumns, rows: transactionRows }}
              showTotalEntries={true}
              isSorted={true}
              noEndBorder
              entriesPerPage={{ defaultValue: 25 }}
              entriesPerPagePosition="bottom-right"
              canSearch={true}
            />
          )}
        </MDBox>
      </DialogContent>
      <DialogActions>
        <MDButton color="secondary" onClick={onClose}>
          Close
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

TransactionsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  transactions: PropTypes.array,
  settlementRecord: PropTypes.object,
};

TransactionsDialog.defaultProps = {
  transactions: [],
  settlementRecord: null,
};

export default TransactionsDialog;
